 // pc
    $(document).ready(function() {
        resetArrow();
    })

    $(window).on('resize', function () {
        resetArrow();
    })

    var redskinsYouTubeVideoSwiper = new Swiper('#redskinsYouTubeVideoContentSwiper',{
        slidesPerView: 'auto',
        grid: {
            fill: 'column',
            rows: 2,
        },
        navigation: {
            nextEl: '#redskinsYouTubeVideoRightArrow',
            prevEl: '#redskinsYouTubeVideoLeftArrow',
        },
    });


    function resetArrow(){

        let redskinsYouTubeVideoArrowDiv = $(".redskinsYouTubeVideoArrowDiv")
        if (window.innerWidth <= 1400 && window.innerWidth >= 1024){
            redskinsYouTubeVideoArrowDiv.css('bottom','3rem');
            redskinsYouTubeVideoArrowDiv.css('width','20rem');
        }else {
            redskinsYouTubeVideoArrowDiv.css('bottom','auto');
            redskinsYouTubeVideoArrowDiv.css('width','134rem');
        }
    }

    function youtubeVideoDivMouseDown(url){
        var videoHtml = '<iframe width="100%" height="100%" src="' + url + '?enablejsapi=1&autoplay=1&fs=1&playsinline=0" class="youtube-player youtubeVideo redskinsYouTubeVideoIframe" frameborder="0" ></iframe>';
        $(".redskinsYouTubeVideoPopupDiv").prepend(videoHtml);
        $(".redskinsYouTubeVideoPopupShowDiv").show();
    }

    $(".redskinsYouTubeVideoClose").click(function() {
        $(".redskinsYouTubeVideoPopupShowDiv").hide();
        $(".redskinsYouTubeVideoIframe").remove();
    })